<template>
  <v-card
    :disabled="loading"
    :loading="loading"
    class="AssignmentFinishedTestCard"
  >
    <v-card-title class="d-flex justify-center">Test finished</v-card-title>
    <v-card-text>
      <v-alert
        v-if="!reportGradeAvailable"
        type="info"
        outlined
      >
        Success data will be available at the end of the assignment test period
      </v-alert>
      <ChipsColumns :items="reportChips" />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="!detailedResultAvailable"
        large
        rounded
        outlined
        color="blue"
        @click="openTestReport"
      >
        <v-icon left>open_in_browser</v-icon>
        Detailed result
      </v-btn>
    </v-card-actions>

    <v-divider class="mt-2" />

    <v-card-title>Run assignment again</v-card-title>
    <v-card-text v-if="attemptsLeft">
      <span>You still have {{ attemptsLeft }} attempts to run the test</span>
      <v-alert
        type="warning"
        text
        border="left"
        class="mt-4"
      >
        Please make sure you have stable internet connection
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="!canRunTest"
        :loading="loading"
        large
        color="primary"
        class="white--text"
        @click="$emit('start')"
      >
        Start test
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import { isNil } from 'lodash';
import ChipsColumns from '@/components/profiles/ChipsColumns';
import { getFinishedReportChips } from '@/helpers/assignments/lists';

export default {
  name: 'AssignmentFinishedTestCard',
  components: {
    ChipsColumns,
  },
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    attemptsLeft: {
      type: Number,
      default: 0,
    },
    canRunTest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lastAssignmentReport() {
      const reports = this.assignment.reports || [];
      return reports[reports.length - 1];
    },
    detailedResultAvailable() {
      return !!this.lastAssignmentReport?.answers?.length;
    },
    reportGradeAvailable() {
      return !isNil(this.lastAssignmentReport.grade);
    },
    reportChips() {
      return getFinishedReportChips(this.lastAssignmentReport);
    },
  },
  methods: {
    openTestReport() {
      const reportId = this.lastAssignmentReport?._id;
      this.$emit('open-report', reportId);
    },
  },
};
</script>
